import {useEffect, useState} from 'react';
import AuthService from '../services/authService';

const Home: React.FC = () => {
    const [jwt, setJwt] = useState('');

    useEffect(() => {
        const authService = new AuthService();
        const jwt = authService.getUserJwt();
        setJwt(jwt !== null ? jwt : '');
    }, []);

    return (
        <div id='HomePage' className='page'>
            <div className='content'>
                ホーム画面<br></br>
                何かダッシュボード的なの実装できたらいいな
                <div className='input-group'>
                    <label>jwt</label>
                    <input type='text' value={jwt} readOnly></input>
                </div>
            </div>
        </div>
    );
};

export default Home;
